var colors = require('../primitives/colors');

var space = require('../primitives/spacing');

var _require = require('../primitives/typography'),
    fontSizes = _require.fontSizes,
    lineHeights = _require.lineHeights;

var theme = {
  colors: colors,
  space: space,
  fontSizes: fontSizes,
  lineHeights: lineHeights
};
module.exports = theme;